"use client";

import { useAdminMode, useUserInfo } from "app/hooks";
import clsx from "clsx";
import { GLOBALS } from "config";
import Cookies from "js-cookie";
import { useRef, useState, MouseEvent, ChangeEvent } from "react";

const ALPHA_DATETIME_COOKIE_NAME = "pekopa_target_at_" + GLOBALS.CONTENT_ID;
export function AdminBar() {
  //current admin date time
  const [currentDateTime, setCurrentAdminDateTime] = useState<string>(
    (Cookies.get(ALPHA_DATETIME_COOKIE_NAME) || "").replace("+", "T"),
  );
  //toggle admin mode
  const { data: inAdminMode, mutate: setInAdminMode } = useAdminMode();
  const { userInfo } = useUserInfo(true);
  const dateTimeInputRef = useRef<HTMLInputElement>(null);

  const handleUpdateDatetime = (e: ChangeEvent | MouseEvent, commit?: boolean) => {
    const datetime = dateTimeInputRef.current?.value;
    if (datetime) {
      setCurrentAdminDateTime(datetime);
      if (commit) {
        //UIからの日付が2025-12-30T56:00の形で来るので、T->+に変換の上秒数の:00を追加してCookieに保存
        Cookies.set(ALPHA_DATETIME_COOKIE_NAME, datetime.replace("T", "+") + ":00", {
          expires: 7,
        });
        location.reload();
      }
    }
  };
  const handleCommitDatetime = (e: MouseEvent) => {
    handleUpdateDatetime(e, true);
  };
  const handleResetDatetime = () => {
    if (currentDateTime) {
      Cookies.remove(ALPHA_DATETIME_COOKIE_NAME);
      location.reload();
    }
  };
  return (
    <div className="admin-bar">
      <span className="admin-bar-date">
        日付&nbsp;
        <input
          className="admin-bar-date-input"
          type="datetime-local"
          value={currentDateTime}
          ref={dateTimeInputRef}
          onChange={handleUpdateDatetime}
        />
        <button
          className={clsx("admin-bar-btn", !currentDateTime && "mode-disabled")}
          onClick={handleCommitDatetime}
        >
          設定
        </button>
        <button
          className={clsx("admin-bar-btn", !currentDateTime && "mode-disabled")}
          onClick={handleResetDatetime}
        >
          リセット
        </button>
      </span>
      {userInfo?.isContentAdmin && (
        <label className="admin-bar-chk-label">
          <input
            className="admin-bar-chk"
            type="checkbox"
            checked={!!inAdminMode}
            onChange={(e) => {
              setInAdminMode(!inAdminMode);
            }}
          />
          管理者モード
        </label>
      )}
    </div>
  );
}
